import { createFileRoute } from "@tanstack/react-router";
import { WalletPage } from "@/routes/_user/wallet";

export const Route = createFileRoute("/admin/wallet")({ component: WalletPage });
